import { createContext, useContext, useState, useCallback, useMemo } from "react";

const translations = {
  en: {
    nav_book: "Book Court", nav_tournaments: "Tournaments", nav_lessons: "Lessons",
    nav_players: "Find Players", nav_members: "Members", nav_dashboard: "Dashboard",
    nav_admin: "Admin",
    login: "Log In", logout: "Log Out", register: "Join Club", signin: "Sign In",
    hero_tag: "Open to everyone · Kos, Greece",
    hero_title: "Play Padel at Kos",
    hero_sub: "Book our single premium padel court in Tigaki, Kos — open to everyone, not just TAF Beach Villas guests. Check live availability and reserve in seconds on Playtomic.",
    hero_cta: "Book The Court", hero_cta2: "Find Players",
    feat_title: "Everything You Need To Play",
    f1_t: "Live Availability", f1_d: "See open slots in real time and reserve instantly.",
    f2_t: "Tournaments", f2_d: "Compete in Americano & knockout events on the island.",
    f3_t: "Coaching", f3_d: "Book lessons with certified padel coaches.",
    f4_t: "Find Players", f4_d: "Match with other players and join open games.",
    f5_t: "Easy Booking", f5_d: "Reserve the court in seconds on Playtomic.",
    f6_t: "Secure Payments", f6_d: "Pay for events & lessons securely with card.",
    availability: "Court Availability", select_date: "Select date",
    available: "Available", booked: "Booked", book_now: "Book",
    my_bookings: "My Bookings", cancel: "Cancel", no_bookings: "No bookings yet.",
    tournaments: "Tournaments", lessons: "Lessons", find_players: "Find Players",
    members: "Members", create: "Create", entry_fee: "Entry fee", free: "Free",
    register_now: "Register", pay_register: "Pay & Register", registered: "Registered",
    full: "Full", participants: "Participants", book_lesson: "Book Lesson",
    pay_book: "Pay & Book", coach: "Coach", price: "Price", capacity: "Capacity",
    post_session: "Post a Session", players_needed: "Players needed", level: "Level",
    request_join: "Request to Join", requested: "Requested", host: "Host",
    requests: "Requests", accept: "Accept", decline: "Decline", confirmed: "Confirmed",
    date: "Date", time: "Time", note: "Note", name: "Name", email: "Email",
    password: "Password", phone: "Phone", loading: "Loading...",
    welcome_back: "Welcome back", create_account: "Create your account",
    or: "or", continue_google: "Continue with Google", no_account: "No account?",
    have_account: "Already a member?", need_login: "Please log in to continue.",
    admin_panel: "Admin", delete: "Delete", processing: "Processing payment...",
    payment_success: "Payment successful!", payment_failed: "Payment failed.",
    back_home: "Back to Dashboard", overview: "Overview", upcoming: "Upcoming sessions",
    my_hosted: "My hosted sessions",
    city: "City / Area", city_hint: "Add your city (e.g. Kos) to get WhatsApp alerts when players near you look for a game.",
    save: "Save", profile: "Profile", profile_saved: "Profile updated",
    gallery_title: "On the court",
    findus_tag: "Find us",
    findus_title: "Where to play",
    findus_address: "TAF Villas Padel — at TAF Beach Villas, Tigaki, Kos 85300, Greece",
    findus_gear: "Rackets and balls are available on site — pick them up at the TAF Beach Villas reception before your session.",
    findus_btn: "Get directions",
    les_wa_intro: "We tailor lessons to your level and schedule. Send us a quick message on WhatsApp and our coach will arrange a time that suits you.",
    les_perk1: "All levels welcome — from first-timers to competitive players",
    les_perk2: "Private or group sessions with an experienced coach",
    les_perk3: "Flexible times, arranged directly with you",
    les_request_wa: "Request a lesson on WhatsApp",
    les_wa_hint: "Opens WhatsApp with a ready-to-send message.",
    les_hours: "Available daily, 08:00–17:00",
    les_price: "Court fee shown on Playtomic at booking",
    les_coach: "Coach is paid separately, on site",
    faq_title: "Frequently asked questions",
    family_tag: "One island · One family",
    family_title: "Make a day of it",
    family_sub: "TAF Villas Padel is part of the TAF family in Tigaki, Kos. Before or after your match, stay, swim and unwind with us.",
    villas_name: "TAF Beach Villas",
    villas_desc: "Private beachfront villas with heated pools, fresh local breakfast, a Tesla to explore the island, and effortless slow living by the Aegean.",
    villas_cta: "Discover the Villas",
    tribe_name: "Tribe Beach Lounge",
    tribe_desc: "Where time flows. Free sunbeds, free SUP & kayak, self-drive boats, a beach spa and the best sunset cocktails on the island — open to everyone, daily till late.",
    tribe_cta: "Visit Tribe Beach",
  },
  el: {
    nav_book: "Κράτηση", nav_tournaments: "Τουρνουά", nav_lessons: "Μαθήματα",
    nav_players: "Βρες Παίκτες", nav_members: "Μέλη", nav_dashboard: "Πίνακας",
    nav_admin: "Διαχείριση",
    login: "Σύνδεση", logout: "Αποσύνδεση", register: "Εγγραφή", signin: "Σύνδεση",
    hero_tag: "Ανοιχτό για όλους · Κως, Ελλάδα",
    hero_title: "Παίξε Padel στην Κω",
    hero_sub: "Κλείστε το μοναδικό premium γήπεδο padel στο Τιγκάκι της Κω — ανοιχτό για όλους, όχι μόνο για τους επισκέπτες των TAF Beach Villas. Δείτε διαθεσιμότητα και κάντε κράτηση σε δευτερόλεπτα μέσω Playtomic.",
    hero_cta: "Κλείσε Γήπεδο", hero_cta2: "Βρες Παίκτες",
    feat_title: "Όλα Όσα Χρειάζεσαι Για Να Παίξεις",
    f1_t: "Ζωντανή Διαθεσιμότητα", f1_d: "Δες ελεύθερες ώρες και κράτησε άμεσα.",
    f2_t: "Τουρνουά", f2_d: "Αγωνίσου σε Americano & knockout διοργανώσεις.",
    f3_t: "Προπόνηση", f3_d: "Κλείσε μαθήματα με πιστοποιημένους προπονητές.",
    f4_t: "Βρες Παίκτες", f4_d: "Βρες συμπαίκτες και μπες σε ανοιχτά παιχνίδια.",
    f5_t: "Εύκολη Κράτηση", f5_d: "Κλείσε το γήπεδο σε δευτερόλεπτα μέσω Playtomic.",
    f6_t: "Ασφαλείς Πληρωμές", f6_d: "Πλήρωσε με κάρτα με ασφάλεια.",
    availability: "Διαθεσιμότητα Γηπέδου", select_date: "Επίλεξε ημερομηνία",
    available: "Διαθέσιμο", booked: "Κλεισμένο", book_now: "Κράτηση",
    my_bookings: "Οι Κρατήσεις μου", cancel: "Ακύρωση", no_bookings: "Καμία κράτηση ακόμη.",
    tournaments: "Τουρνουά", lessons: "Μαθήματα", find_players: "Βρες Παίκτες",
    members: "Μέλη", create: "Δημιουργία", entry_fee: "Κόστος", free: "Δωρεάν",
    register_now: "Εγγραφή", pay_register: "Πληρωμή & Εγγραφή", registered: "Εγγεγραμμένος",
    full: "Πλήρες", participants: "Συμμετέχοντες", book_lesson: "Κράτηση Μαθήματος",
    pay_book: "Πληρωμή & Κράτηση", coach: "Προπονητής", price: "Τιμή", capacity: "Θέσεις",
    post_session: "Δημοσίευσε Παιχνίδι", players_needed: "Παίκτες που λείπουν", level: "Επίπεδο",
    request_join: "Αίτημα Συμμετοχής", requested: "Στάλθηκε", host: "Διοργανωτής",
    requests: "Αιτήματα", accept: "Αποδοχή", decline: "Απόρριψη", confirmed: "Επιβεβαιωμένοι",
    date: "Ημερομηνία", time: "Ώρα", note: "Σημείωση", name: "Όνομα", email: "Email",
    password: "Κωδικός", phone: "Τηλέφωνο", loading: "Φόρτωση...",
    welcome_back: "Καλώς ήρθες", create_account: "Δημιούργησε λογαριασμό",
    or: "ή", continue_google: "Συνέχεια με Google", no_account: "Δεν έχεις λογαριασμό;",
    have_account: "Είσαι ήδη μέλος;", need_login: "Συνδέσου για να συνεχίσεις.",
    admin_panel: "Διαχείριση", delete: "Διαγραφή", processing: "Επεξεργασία πληρωμής...",
    payment_success: "Η πληρωμή ολοκληρώθηκε!", payment_failed: "Η πληρωμή απέτυχε.",
    back_home: "Πίσω στον Πίνακα", overview: "Επισκόπηση", upcoming: "Επερχόμενα παιχνίδια",
    my_hosted: "Παιχνίδια που διοργανώνω",
    city: "Πόλη / Περιοχή", city_hint: "Πρόσθεσε την πόλη σου (π.χ. Κως) για να λαμβάνεις ειδοποιήσεις WhatsApp όταν παίκτες κοντά σου ψάχνουν παιχνίδι.",
    save: "Αποθήκευση", profile: "Προφίλ", profile_saved: "Το προφίλ ενημερώθηκε",
    gallery_title: "Στο γήπεδο",
    findus_tag: "Βρες μας",
    findus_title: "Πού θα παίξεις",
    findus_address: "TAF Villas Padel — στο TAF Beach Villas, Τιγκάκι, Κως 85300, Ελλάδα",
    findus_gear: "Ρακέτες και μπάλες διαθέσιμες επιτόπου — παραλαβή από τη ρεσεψιόν του TAF Beach Villas πριν το παιχνίδι σου.",
    findus_btn: "Οδηγίες",
    les_wa_intro: "Προσαρμόζουμε τα μαθήματα στο επίπεδο και το πρόγραμμά σου. Στείλε μας ένα μήνυμα στο WhatsApp και ο προπονητής μας θα κανονίσει μια ώρα που σε βολεύει.",
    les_perk1: "Όλα τα επίπεδα — από αρχάριους έως αγωνιστικούς παίκτες",
    les_perk2: "Ατομικά ή ομαδικά μαθήματα με έμπειρο προπονητή",
    les_perk3: "Ευέλικτες ώρες, κανονισμένες απευθείας μαζί σου",
    les_request_wa: "Ζήτησε μάθημα στο WhatsApp",
    les_wa_hint: "Ανοίγει το WhatsApp με έτοιμο μήνυμα.",
    les_hours: "Διαθέσιμα καθημερινά, 08:00–17:00",
    les_price: "Η χρέωση γηπέδου εμφανίζεται στο Playtomic κατά την κράτηση",
    les_coach: "Ο προπονητής πληρώνεται ξεχωριστά, επιτόπου",
    faq_title: "Συχνές ερωτήσεις",
    family_tag: "Ένα νησί · Μία οικογένεια",
    family_title: "Κάντε το μια ολόκληρη μέρα",
    family_sub: "Το TAF Villas Padel είναι μέρος της οικογένειας TAF στο Τιγκάκι της Κω. Πριν ή μετά το παιχνίδι, μείνετε, κολυμπήστε και χαλαρώστε μαζί μας.",
    villas_name: "TAF Beach Villas",
    villas_desc: "Ιδιωτικές παραθαλάσσιες βίλες με θερμαινόμενες πισίνες, φρέσκο τοπικό πρωινό, ένα Tesla για να εξερευνήσετε το νησί και ανέμελη διαβίωση δίπλα στο Αιγαίο.",
    villas_cta: "Ανακαλύψτε τις Βίλες",
    tribe_name: "Tribe Beach Lounge",
    tribe_desc: "Εκεί που ο χρόνος κυλά. Δωρεάν ξαπλώστρες, δωρεάν SUP & καγιάκ, σκάφη χωρίς δίπλωμα, beach spa και τα καλύτερα κοκτέιλ ηλιοβασιλέματος στο νησί — ανοιχτά για όλους, καθημερινά ως αργά.",
    tribe_cta: "Επισκεφθείτε το Tribe Beach",
  },
};

export const FAQS = {
  en: [
    { q: "How much does it cost to rent the padel court in Kos?", a: "A padel court session lasts 90 minutes. Prices vary by time of day — the current price is always shown on Playtomic when you book, so it's never out of date." },
    { q: "Where is the padel court located on Kos Island?", a: "Our single premium padel court is in Tigaki, Kos Island, Greece, as part of TAF Beach Villas — easy to reach from Kos Town, Tigaki and Marmari." },
    { q: "Can I rent a racket and balls?", a: "Yes. You can arrange a racket or balls and pick your gear up at the TAF Beach Villas reception before your session." },
    { q: "Can I find other players to play padel with?", a: "Yes — use Playtomic's player matching to find opponents and join open games in Kos." },
    { q: "Do you organise padel tournaments?", a: "Yes, we run tournaments (such as Americano and knockout formats). Sign up for upcoming events through Playtomic." },
    { q: "How do I book a padel court in Kos?", a: "Click any 'Book' button on this site to open our Playtomic booking page, pick a date and an available 90-minute slot, and pay securely to confirm." },
  ],
  el: [
    { q: "Πόσο κοστίζει η ενοικίαση του γηπέδου padel στην Κω;", a: "Μια συνεδρία padel διαρκεί 90 λεπτά. Οι τιμές διαφέρουν ανάλογα με την ώρα — η τρέχουσα τιμή εμφανίζεται πάντα στο Playtomic κατά την κράτηση, ώστε να είναι πάντα ενημερωμένη." },
    { q: "Πού βρίσκεται το γήπεδο padel στην Κω;", a: "Το μοναδικό premium γήπεδο padel βρίσκεται στο Τιγκάκι, Κως, Ελλάδα, ως μέρος των TAF Beach Villas — με εύκολη πρόσβαση από την πόλη της Κω, το Τιγκάκι και το Μαρμάρι." },
    { q: "Μπορώ να νοικιάσω ρακέτα και μπαλάκια;", a: "Ναι. Μπορείτε να κανονίσετε ρακέτα ή μπαλάκια και να τα παραλάβετε από τη ρεσεψιόν των TAF Beach Villas πριν το παιχνίδι." },
    { q: "Μπορώ να βρω άλλους παίκτες για padel;", a: "Ναι — χρησιμοποιήστε το player matching του Playtomic για να βρείτε αντιπάλους και να μπείτε σε ανοιχτά παιχνίδια στην Κω." },
    { q: "Διοργανώνετε τουρνουά padel;", a: "Ναι, διοργανώνουμε τουρνουά (όπως Americano και knockout). Δηλώστε συμμετοχή στις επερχόμενες διοργανώσεις μέσω Playtomic." },
    { q: "Πώς κλείνω γήπεδο padel στην Κω;", a: "Πατήστε οποιοδήποτε κουμπί «Κράτηση» σε αυτόν τον ιστότοπο για να ανοίξει η σελίδα κράτησης Playtomic, επιλέξτε ημερομηνία και διαθέσιμη ώρα 90 λεπτών και πληρώστε με ασφάλεια για επιβεβαίωση." },
  ],
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("taf_lang") || "en");
  const toggle = useCallback(() => {
    setLang((l) => {
      const n = l === "en" ? "el" : "en";
      localStorage.setItem("taf_lang", n);
      return n;
    });
  }, []);
  const t = useCallback((key) => translations[lang][key] || key, [lang]);
  const value = useMemo(() => ({ lang, toggle, t }), [lang, toggle, t]);
  return (
    <LangContext.Provider value={value}>{children}</LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
